import Reveal from "@/components/site/Reveal";
import BookButton from "@/components/site/BookButton";

export default function CTASection() {
    return (
        <section
            data-testid="cta-section"
            className="relative bg-[#020617] py-24 md:py-36 overflow-hidden"
        >
            <div className="absolute inset-0 opacity-[0.07] pointer-events-none">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-display font-black text-white text-[28rem] tracking-tighter leading-none select-none">
                    90
                </div>
            </div>

            <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
                <Reveal>
                    <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#D4AF37]">
                        Your Move
                    </p>
                    <h2 className="mt-8 font-display font-black text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.98] tracking-tighter">
                        Ninety days from now, you’ll either be the{" "}
                        <span className="text-[#D4AF37]">same man</span>… or a
                        completely different one.
                    </h2>
                    <p className="mt-8 text-white/75 leading-relaxed text-base sm:text-lg max-w-2xl mx-auto">
                        Book a free 30-minute consultation. We’ll diagnose
                        exactly where you’re stuck, walk you through the
                        program, and decide together if you’re a fit. Zero
                        pressure. Real clarity.
                    </p>
                    <div className="mt-12 flex flex-col sm:flex-row gap-4 items-stretch sm:items-center justify-center">
                        <BookButton
                            testId="cta-book-primary"
                            label="Book a Free Consultation"
                            size="lg"
                        />
                        <a
                            href="/pricing"
                            data-testid="cta-enroll-link"
                            className="inline-flex items-center justify-center gap-2 px-8 py-4 text-sm uppercase tracking-[0.18em] font-bold bg-transparent border border-[#1a2a4a] text-white hover:border-[#1E90FF] hover:text-[#00B7FF] hover:shadow-[0_0_30px_rgba(30,144,255,0.3)] transition-all"
                        >
                            Enroll Now — $2,999
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
